import {useEffect, useRef, useState} from 'react';
import Guacamole from 'guacamole-common-js';
import styles from "./style.module.scss";

const GuacamoleClient = ({url, token, guac, setGuac}: any) => {
    const ref = useRef<any>(null);
    const [keyboard, setKeyboard] = useState<any>(null);  // State to store the keyboard instance

    useEffect(() => {
        if (ref.current) {
            // Create the Guacamole client.
            const guacClient = new Guacamole.Client(new Guacamole.WebSocketTunnel(url));

            setGuac(guacClient);

            // Attach the Guacamole client to an element.
            ref.current.appendChild(guacClient.getDisplay().getElement());

            // Set the initial display size.
            // guacClient.getDisplay().onresize = (width, height) => {
            //     const displayElement = guacClient.getDisplay().getElement();
            //     displayElement.style.width = width + 'px';
            //     displayElement.style.height = height + 'px';
            // };

            guacClient.connect(`token=${token}`);

            // Step 3: Initialize the keyboard to capture the input from the document (global capture)
            const guacKeyboard = new Guacamole.Keyboard(document);
            setKeyboard(guacKeyboard);

            // When closing the browser tab or leaving this page
            const disconnectGuacClient = () => {
                guacClient.disconnect();
            };

            // Step 4: Create a Mouse instance to capture mouse events on the guacClient display
            const guacMouse: any = new Guacamole.Mouse(guacClient.getDisplay().getElement());

            // Attach handler for mouse events. These will be automatically translated into
            // Guacamole-specific messages that will be sent to the VNC server.
            guacMouse.onmousedown = (mouseState: any) => {
                guacClient.sendMouseState(mouseState);
            };

            guacMouse.onmousemove = (mouseState: any) => {
                guacClient.sendMouseState(mouseState);
            };

            guacMouse.onmouseup = (mouseState: any) => {
                guacClient.sendMouseState(mouseState);
            };

            window.addEventListener('beforeunload', disconnectGuacClient);

            // Cleanup function
            return () => {
                window.removeEventListener('beforeunload', disconnectGuacClient);
                guacClient.disconnect();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, token]);

    // Step 4: Capture and send key events to the Guacamole server (VNC session)
    useEffect(() => {
        if (keyboard && guac) {
            // Handle keydown event (when key is pressed)
            keyboard.onkeydown = (keysym: any) => {
                guac.sendKeyEvent(1, keysym);  // 1 = keyDown event
                return false; // Prevent default browser behavior (e.g., form submission)
            };

            // Handle keyup event (when key is released)
            keyboard.onkeyup = (keysym: any) => {
                guac.sendKeyEvent(0, keysym);  // 0 = keyUp event
                return false;
            };
        }
    }, [keyboard, guac]);

    return (
        <div
            ref={ref}
            className={styles.Guacamole}
            onClick={() => ref.current.focus()}
        />
    );
};

export default GuacamoleClient;